module.exports = __webpack_public_path__ + "static/media/noWifi.0d7a75ae.svg";